import { useState } from 'react';
import Card from '@material-tailwind/react/Card';
import CardBody from '@material-tailwind/react/CardBody';
import Button from '@material-tailwind/react/Button';
import Paragraph from '@material-tailwind/react/Paragraph';
import Icon from '@material-tailwind/react/Icon';
import { Link } from 'react-router-dom';

import Modal from 'components/general/Modal';
import SignatureModal from 'components/sign/SignatureModal';
import UpdateEmailModalForm from 'components/profile/UpdateEmailModalForm';
import UpdateDetailsModalForm from 'components/profile/UpdateDetailsModalForm';

import { useGlobalState } from 'state-pool';
import { editUser } from 'routes/userRoutes';

export default function ProfileDetails() {
    const [showEnable2faConfirm, setShowEnable2faConfirm] = useState(false);
    const [twoFaEnabled, setTwoFaEnabled] = useState(false);
    const [showSign, setShowSign] = useState(false);
    const [showEmailNotificationsModal, setShowEmailNotificationsModal] = useState(false);
    const [showUpdateEmail, setShowUpdateEmail] = useState(false);
    const [showUpdateDetails, setShowUpdateDetails] = useState(false);
    const [emailNotificationsEnabled, setEmailNotificationsEnabled] = useState(false);
    const [currentUser] = useGlobalState('currentUser');
    // const [userSignature, setUserSignature] = useState("data:image/png;base64,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");

    function saveUserSignature(sig) {
        // setUserSignature(sig);

        setShowSign(false);
    }

    return (
        <>
            <div className="h-10" />
            <Card className="mb-2">
                <CardBody>
                    <div className="relative h-10">
                        <div className="inline left">
                            <h5 className="text-gray-500 font-light tracking-wide text-xs">Full name</h5>
                            <span className="text-sm text-black font-light">{currentUser && currentUser.name_first} {currentUser && currentUser.name_last}</span>
                        </div>
                        {/* --------CM---------
                        Disabled until resigning has been implemented
                        This Button allows the users to update there details*/}
                        {/* <Button color="green" onClick={() => setShowUpdateDetails(true)} className="inline float-right hover:bg-transparent" buttonType="outline">
                            Update
                        </Button> */}
                    </div>
                </CardBody>
            </Card>
            {/* <Link to="/profile/update-email"> */}
            <Card className="mb-2 transition group">
                <CardBody>
                    <div className="flex justify-between items-center relative h-10">
                        <div >
                            <h5 className="text-gray-500 font-light tracking-wide text-xs">Email</h5>
                            <span className="text-sm text-black font-light">{currentUser && currentUser.email}</span>
                        </div>
                        {/* The feature to change your username is not working and for now is disabled */}
                        {/* <Button
                            color=""
                            className="h-full items-center group-hover:pl-4"
                            buttonType="link"
                            size="sm"
                            iconOnly
                            rounded
                            ripple="light"
                            onClick={() => { }}
                        >
                            <Icon name="arrow_forward" size="2xl" color="black" />
                        </Button> */}
                        {/* <Button color="green" onClick={() => setShowUpdateEmail(true)} className="inline float-right hover:bg-transparent" buttonType="outline">
                            Update
                        </Button> */}
                    </div>
                </CardBody>
            </Card>
            {/* </Link> */}
            {/* {currentUser && currentUser.phone_main &&
                <Card className="mb-2">
                    <CardBody>
                        <div className="relative h-10">
                            <div className="inline left">
                                <h5 className="text-gray-500 font-light tracking-wide text-xs">Phone Number</h5>
                                <span className="text-sm text-black font-light">{currentUser && currentUser.phone_main}</span>
                            </div>
                            <Button color="green" onClick={() => setShowUpdateDetails(true)} className="inline float-right hover:bg-transparent" buttonType="outline">
                                Update
                            </Button>
                        </div>
                    </CardBody>
                </Card>} */}
            {/* <Card className="mb-2">
                <CardBody>
                    <div className="w-full flex h-36">
                        <div className="flex flex-col">
                            <h5 className="text-gray-500 font-light tracking-wide text-xs">Your signature</h5>
                            <img className="h-32 w-auto" alt="your_signature" src={userSignature}/> 
                        </div>
                        <Button color="green" onClick={() => setShowSign(true)} className="ml-auto h-10 hover:bg-transparent" buttonType="outline">
                            Update
                        </Button>
                    </div>
                </CardBody>
            </Card> */}
            {/* <Card className="mb-2">
                <CardBody>
                    <div className="relative h-10">
                        <div className="inline left">
                            <h5 className="text-gray-500 font-light tracking-wide text-xs">2FA status</h5>
                            <span className="text-sm text-black font-light">{twoFaEnabled ? "Enabled" : "Disabled"}</span>
                        </div>
                        {twoFaEnabled ? (
                            <Button color="green" onClick={() => setShowEnable2faConfirm(true)} className="inline float-right hover:bg-transparent" buttonType="outline">
                                Disable
                            </Button>
                        ) : (
                            <Button color="green" onClick={() => setShowEnable2faConfirm(true)} className="inline float-right hover:bg-transparent" buttonType="outline">
                                Enable
                            </Button>    
                        )}
                    </div>
                </CardBody>
            </Card> */}
            <Modal
                showModal={showEnable2faConfirm}
                setShowModal={setShowEnable2faConfirm}
                title={!twoFaEnabled ? "Enable 2 factor authentication" : "Disable 2 factor authentication"}
                size="regular"
            >
                <Paragraph>
                    {twoFaEnabled ?
                        `Are you sure you want to disable 2 factor authentication?` :
                        `Enabling 2 factor authentication helps secure your acount. Each time you log in, we will email you a 4 digit code which you will enter as an extra step after email & password validation.`
                    }
                </Paragraph>
                <Button
                    onClick={() => {
                        setShowEnable2faConfirm(false);
                        setTimeout(() => {
                            setTwoFaEnabled(!twoFaEnabled);
                        }, 500);
                    }}
                    color={!twoFaEnabled ? "green" : "orange"}
                    className="inline float-right border-primary"
                    buttonType="fill"
                >
                    {twoFaEnabled ? "Disable" : "Enable"}
                </Button>
                <Button
                    onClick={() => setShowEnable2faConfirm(false)}
                    color="red"
                    className="inline mr-2 float-right border-primary hover:bg-red hover:text-white"
                    buttonType="outline"
                    ripple="dark"
                >
                    Cancel
                </Button>
            </Modal>
            <Modal
                showModal={showEmailNotificationsModal}
                setShowModal={setShowEmailNotificationsModal}
                title={!emailNotificationsEnabled ? "Enable login notifications" : "Disable login notifications"}
                size="regular"
            >
                <Paragraph>
                    {emailNotificationsEnabled ?
                        `Are you sure you want to disable login notifications?` :
                        `Enabling login notifications helps secure your acount. Each time a log in on your account occurs, we will email you. If it was not you, you can flag the activity in the email. We will immediately end that session and send you a reset password email, weher you'll be able to regain access to you account.`
                    }
                </Paragraph>
                <Button
                    onClick={() => {
                        setShowEmailNotificationsModal(false);
                        setTimeout(() => {
                            setEmailNotificationsEnabled(!emailNotificationsEnabled);
                        }, 500);
                    }}
                    color={!emailNotificationsEnabled ? "green" : "orange"}
                    className="inline float-right border-primary"
                    buttonType="fill"
                >
                    {emailNotificationsEnabled ? "Disable" : "Enable"}
                </Button>
                <Button
                    onClick={() => setShowEmailNotificationsModal(false)}
                    color="red"
                    className="inline mr-2 float-right border-primary"
                    buttonType="outline"
                >
                    Cancel
                </Button>
            </Modal>
            <Modal
                showModal={showUpdateEmail}
                setShowModal={setShowUpdateEmail}
                title={" "}
                size="regular"
            >
                <UpdateEmailModalForm setShowModal={setShowUpdateEmail} editUser={editUser} />
            </Modal>
            <Modal
                showModal={showUpdateDetails}
                setShowModal={setShowUpdateDetails}
                title={" "}
                size="regular"
            >
                <UpdateDetailsModalForm editUser={editUser} setShowModal={setShowUpdateDetails} />
            </Modal>
            <SignatureModal
                show={showSign}
                setShow={setShowSign}
                save={(sigBase64) => saveUserSignature(sigBase64)}
            />
        </>
    );
}
